import React from "react";
import PreApproveButton from "@components/FlowActionButtons/PreApproveButton";
import type { Task } from "@services/vesselCall/types";
import { canUserPreApprove } from "../utils";

interface PreApproveVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const PreApproveVesselCall: React.FC<PreApproveVesselCallProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
}) => {
  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserPreApprove(
    vesselCallFlowData.task.status,
    vesselCallFlowData.task.claimOwnerName,
    vesselCallFlowData.status,
  );

  const handleApproveClick = () => {
    refetchVesselCall();
    openDrawer("preApproveDrawer");
  };
  return (
    <PreApproveButton
      langBase={LANG_BASE}
      permission="canPreApproveVesselCall"
      isActionAvailable={isActionAvailable}
      onApprove={handleApproveClick}
    />
  );
};
export default PreApproveVesselCall;
